import { useSelector } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { getDeliveryDaysError, getPostcodePending } from 'routes/Signup/signupSelectors'
import {
  getBasketIsPortionSizeViewVisible,
  getBasketIsShowDetailsViewFirst,
  getBasketOrderId,
  getBasketPostcode,
  getBasketSlotId,
} from 'selectors/basket'
import { getReceiveMenuPending } from 'selectors/root'
import { createGetActionTypeIsPending } from 'selectors/status'

import { getHasProspectNotSeenWizard } from '../selectors/menu'

export enum BoxSummaryViews {
  POSTCODE = 'POSTCODE',
  DELIVERY_SLOT = 'DELIVERY_SLOT',
  DETAILS = 'DETAILS',
  PORTION_SIZE = 'PORTION_SIZE',
}

export function useGetCurrentBoxSummaryView() {
  const postcode = useSelector(getBasketPostcode)
  const deliveryDaysError = useSelector(getDeliveryDaysError)
  const isPostcodePending = useSelector(getPostcodePending)
  const slotId = useSelector(getBasketSlotId)
  const orderId = useSelector(getBasketOrderId)
  const prospectHasNotSeenWizard = useSelector(getHasProspectNotSeenWizard)
  const isPortionSizeViewVisible = useSelector(getBasketIsPortionSizeViewVisible)
  const isShowDetailsViewFirst = useSelector(getBasketIsShowDetailsViewFirst)
  const isReceiveMenuPending = useSelector(getReceiveMenuPending)
  const isMenuFetchDataPending = useSelector(
    createGetActionTypeIsPending(actionTypes.MENU_FETCH_DATA),
  )

  const isMenuPending = isReceiveMenuPending || isMenuFetchDataPending

  const noPostcode = !postcode
  const noOrderId = !orderId
  const noSlotId = !slotId

  const hasProspectNotSeenWizard = prospectHasNotSeenWizard && isShowDetailsViewFirst

  const showPostcode = (noPostcode || deliveryDaysError || isPostcodePending) && noOrderId

  const showDeliverySlot = ((!showPostcode && noSlotId) || isMenuPending) && noOrderId

  const showPortionsSizeView = !showPostcode && !showDeliverySlot && isPortionSizeViewVisible

  const showDetailsView = !showPostcode && !showDeliverySlot

  let currentView

  if (hasProspectNotSeenWizard) {
    currentView = BoxSummaryViews.DETAILS
  } else if (showPostcode) {
    currentView = BoxSummaryViews.POSTCODE
  } else if (showDeliverySlot) {
    currentView = BoxSummaryViews.DELIVERY_SLOT
  } else if (showPortionsSizeView) {
    currentView = BoxSummaryViews.PORTION_SIZE
  } else if (showDetailsView) {
    currentView = BoxSummaryViews.DETAILS
  }

  return currentView
}
